import React from 'react'

export default function PrivacyPolicy() {
  return (
    <div className="bg-slate-50 min-h-screen">
      {/* Page Header */}
      <section className="bg-white pt-16 pb-8 border-b border-slate-200">
        <div className="mx-auto max-w-4xl px-4 text-center space-y-3">
          <h1 className="text-3xl font-semibold sm:text-4xl lg:text-5xl text-slate-900">Privatlivspolitik</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Privatlivspolitik for Probyg Maler ApS
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12 sm:py-16">
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
          <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-10 shadow-sm space-y-8">
            
            {/* 1. Dataansvarlig */}
            <div>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Dataansvarlig</h2>
              <div className="bg-slate-50 rounded-xl p-5 border border-slate-100 space-y-1 text-sm text-slate-700 mb-4">
                <p className="font-semibold text-slate-900">Probyg Maler ApS</p>
                <p>CVR-nr.: 46347870</p>
                <p>Adresse: Njalsgade 21F, 2.</p>
                <p>Telefon: 92 90 00 91</p>
                <p>E-mail: info@probyg.tech</p>
              </div>
              <p className="text-slate-600 leading-relaxed">
                Probyg Maler ApS er dataansvarlig for behandlingen af de personoplysninger, vi modtager via vores hjemmeside og i forbindelse med vores kunderelationer.
              </p>
            </div>

            {/* 2. Hvilke oplysninger indsamler vi? */}
            <div>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Hvilke oplysninger indsamler vi?</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Når du kontakter os via hjemmesidens kontaktformular, telefon eller e-mail, kan vi indsamle følgende oplysninger:
              </p>
              <ul className="list-disc pl-5 space-y-1.5 text-slate-600">
                <li>Navn</li>
                <li>Telefonnummer</li>
                <li>E-mailadresse</li>
                <li>Adresse</li>
                <li>Oplysninger om den ønskede maleropgave</li>
                <li>Eventuelle øvrige oplysninger, som du selv vælger at oplyse</li>
              </ul>
            </div>

            {/* 3. Formålet med behandlingen */}
            <div>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Formålet med behandlingen</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Vi behandler dine personoplysninger med henblik på:
              </p>
              <ul className="list-disc pl-5 space-y-1.5 text-slate-600">
                <li>At besvare henvendelser og forespørgsler</li>
                <li>At udarbejde tilbud</li>
                <li>At udføre aftalte maleropgaver</li>
                <li>At administrere kundeforhold</li>
                <li>At fremsende fakturaer</li>
                <li>At overholde gældende lovgivning, herunder bogføringsloven</li>
                <li>At forbedre vores markedsføring og hjemmeside</li>
              </ul>
            </div>

            {/* 4. Retsgrundlag */}
            <div>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Retsgrundlag</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Vi behandler dine oplysninger på baggrund af:
              </p>
              <ul className="list-disc pl-5 space-y-1.5 text-slate-600">
                <li>Dit samtykke, når du udfylder kontaktformularen</li>
                <li>Opfyldelse af en aftale eller tilbudsproces</li>
                <li>Vores legitime interesse i at drive og markedsføre virksomheden</li>
                <li>Overholdelse af lovgivningsmæssige forpligtelser</li>
              </ul>
            </div>

            {/* 5. Cookies, Meta Pixel og Google Analytics */}
            <div>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Cookies, Meta Pixel og Google Analytics</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Vores hjemmeside anvender cookies og lignende teknologier.
              </p>
              <p className="text-slate-600 leading-relaxed mb-3">
                Vi bruger blandt andet:
              </p>
              <ul className="list-disc pl-5 space-y-1.5 text-slate-600 mb-4">
                <li>Meta Pixel (Facebook Pixel)</li>
                <li>Google Analytics</li>
              </ul>
              <p className="text-slate-600 leading-relaxed mb-3">
                Disse værktøjer hjælper os med at forstå, hvordan besøgende bruger hjemmesiden, måle effekten af vores annoncer samt vise relevante annoncer på Facebook og Instagram.
              </p>
              <p className="text-slate-600 leading-relaxed mb-3">
                Ved brug af disse værktøjer kan oplysninger om dit besøg på hjemmesiden blive behandlet, herunder IP-adresse, browseroplysninger, besøgte sider og handlinger på hjemmesiden.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Behandlingen sker på baggrund af dit samtykke via vores cookiebanner.
              </p>
            </div>

            {/* 6. Videregivelse af oplysninger */}
            <div>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Videregivelse af oplysninger</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Vi sælger aldrig dine personoplysninger.
              </p>
              <p className="text-slate-600 leading-relaxed mb-3">
                Oplysninger kan deles med betroede samarbejdspartnere og databehandlere, som hjælper os med:
              </p>
              <ul className="list-disc pl-5 space-y-1.5 text-slate-600 mb-4">
                <li>Hosting af hjemmesiden</li>
                <li>Drift af e-mail</li>
                <li>Analyseværktøjer</li>
                <li>Markedsføring</li>
                <li>Regnskab og administration</li>
              </ul>
              <p className="text-slate-600 leading-relaxed">
                Disse parter må kun behandle oplysningerne efter vores instrukser og i overensstemmelse med gældende databeskyttelsesregler.
              </p>
            </div>

            {/* 7. Opbevaring af oplysninger */}
            <div>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Opbevaring af oplysninger</h2>
              <p className="text-slate-600 leading-relaxed mb-3">
                Vi opbevarer personoplysninger så længe, det er nødvendigt for at opfylde formålet med behandlingen.
              </p>
              <p className="text-slate-600 leading-relaxed mb-3">
                Regnskabsmateriale opbevares i henhold til gældende lovgivning.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Henvendelser via kontaktformular og e-mail slettes løbende, når de ikke længere er relevante.
              </p>
            </div>

            {/* 8. Dine rettigheder */}
            <div>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Dine rettigheder</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Du har ret til:
              </p>
              <ul className="list-disc pl-5 space-y-1.5 text-slate-600 mb-4">
                <li>At få indsigt i de oplysninger, vi behandler om dig</li>
                <li>At få rettet urigtige oplysninger</li>
                <li>At få slettet oplysninger, når lovgivningen tillader det</li>
                <li>At få begrænset behandlingen</li>
                <li>At gøre indsigelse mod behandlingen</li>
                <li>At modtage dine oplysninger i et struktureret format (dataportabilitet)</li>
              </ul>
              <p className="text-slate-600 leading-relaxed">
                Ønsker du at gøre brug af dine rettigheder, kan du kontakte os via de kontaktoplysninger, der fremgår ovenfor.
              </p>
            </div>

            {/* 9. Klage */}
            <div>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Klage</h2>
              <p className="text-slate-600 leading-relaxed">
                Hvis du er utilfreds med vores behandling af dine personoplysninger, kan du indgive en klage til Datatilsynet.
              </p>
            </div>

            {/* 10. Kontakt */}
            <div>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">10. Kontakt</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Har du spørgsmål til denne privatlivspolitik eller vores behandling af personoplysninger, er du velkommen til at kontakte os:
              </p>
              <div className="bg-slate-50 rounded-xl p-5 border border-slate-100 space-y-1 text-sm text-slate-700">
                <p className="font-semibold text-slate-900">Probyg Maler ApS</p>
                <p>CVR-nr.: 46347870</p>
                <p>E-mail: info@probyg.tech</p>
                <p>Telefon: 92 90 00 91</p>
              </div>
            </div>

            {/* Last Updated */}
            <div className="pt-6 border-t border-slate-100 text-xs text-slate-400 text-right">
              Senest opdateret: 17. juni 2026
            </div>

          </div>
        </div>
      </section>
    </div>
  )
}
